import {NavLink} from 'react-router';

import styled from 'styled-components';

import {link} from './styles';

const BreadcrumbLink = styled(NavLink)`
  display: flex;
  align-items: center;
  ${link};
`;

export {BreadcrumbLink};
